import(/* webpackMode: "eager" */ "/app/client/src/app/global-error.tsx");
